import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["id"];
// @ts-expect-error untyped module reference-resolvers
import { SLACK_CHANNEL } from 'reference-resolvers/constants/ReferenceObjectTypes';
// @ts-expect-error untyped module reference-resolvers
import ReferenceIdType from 'reference-resolvers/schema/ReferenceIdType';
// @ts-expect-error untyped module customer-reference-ui-components
import ReferenceName from 'customer-data-reference-ui-components/name/ReferenceName';
import { jsx as _jsx } from "react/jsx-runtime";
const SlackChannelName = _ref => {
  let {
      id
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(ReferenceName, Object.assign({
    id: id,
    referenceObjectType: SLACK_CHANNEL
  }, rest));
};
SlackChannelName.propTypes = {
  id: ReferenceIdType.isRequired
};
export default SlackChannelName;